import { render, staticRenderFns } from "./GiftCertificate.vue?vue&type=template&id=d846a44c&scoped=true"
import script from "./GiftCertificate.vue?vue&type=script&lang=js"
export * from "./GiftCertificate.vue?vue&type=script&lang=js"
import style0 from "./GiftCertificate.vue?vue&type=style&index=0&id=d846a44c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d846a44c",
  null
  
)

export default component.exports